import React from "react";
import { Link } from "react-router-dom";
import PolicyPage, { SupportEmail } from "./PolicyPage";

const policyGroups = [
  {
    title: "Shopping and orders",
    links: [
      ["Shipping & Delivery", "/shipping"],
      ["Refunds & Returns", "/returns"],
      ["Payment & Security", "/payments"],
      ["Orders & Cancellations", "/orders-cancellations"],
      ["Custom & Made-to-Order", "/custom-orders"],
      ["Pricing & Promotions", "/promotions-pricing"],
    ],
  },
  {
    title: "Products and aftercare",
    links: [
      ["Product Information", "/product-information"],
      ["Warranty & Repairs", "/warranty-repairs"],
      ["Product Care & Safety", "/care-safety"],
      ["Frequently Asked Questions", "/faqs"],
    ],
  },
  {
    title: "Privacy and legal",
    links: [
      ["Privacy Policy", "/privacy"],
      ["Privacy Choices", "/privacy-choices"],
      ["Cookie Policy", "/cookies"],
      ["Terms of Service", "/terms"],
      ["Intellectual Property", "/intellectual-property"],
      ["Website Disclaimer", "/disclaimer"],
    ],
  },
  {
    title: "Support and inclusion",
    links: [
      ["Accessibility Statement", "/accessibility"],
      ["Complaints & Dispute Resolution", "/complaints"],
      ["Contact Us", "/contact"],
    ],
  },
];

function PolicyCenter() {
  return (
    <PolicyPage title="Policy Center">
      <p>
        This center brings together the policies that apply when you browse or
        shop with Tuddlepetgoods. The policy in force when your order is
        accepted will apply to that purchase, subject to any non-waivable
        rights under applicable law.
      </p>
      <div className="policy__index" aria-label="Store policies">
        {policyGroups.map((group) => (
          <section className="policy__group" key={group.title}>
            <h2>{group.title}</h2>
            <ul>
              {group.links.map(([label, path]) => (
                <li key={path}>
                  <Link to={path}>{label}</Link>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
      <p>
        If you cannot find the information you need, email <SupportEmail />.
        We will direct your question to the appropriate support channel.
      </p>
    </PolicyPage>
  );
}

export default PolicyCenter;
